
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { onUpdateAvailable } from "@/registerServiceWorker";

@Component({})
export default class AppComponent extends Vue {
  async created(): Promise<void> {
    await this.$store.dispatch("AuthStore/handleRedirectCallback");
  }

  mounted(): void {
    onUpdateAvailable((waiting) => {
      const h = this.$createElement;
      const body = h("div", { class: "d-flex align-items-center" }, [
        h("span", { class: "mr-2" }, "A new version is available."),
        h(
          "b-button",
          {
            props: { size: "sm", variant: "primary" },
            on: { click: () => waiting?.postMessage({ type: "SKIP_WAITING" }) },
          },
          "Reload"
        ),
      ]);
      this.$bvToast.toast([body], {
        title: "Update available",
        variant: "info",
        solid: true,
        noAutoHide: true,
      });
    });
  }
}
